import React, { useMemo } from "react";
import * as echarts from "echarts";
import { default as EchartsWrapper } from "src/components/Echarts";
import { peerAnalyticsPublishType } from "src/types/analytics";
import { getPublisherQualityLimitationChartConfiguration } from "../../helpers/getPublishConfigurations";
type echartsOptions = echarts.EChartsOption;

export const PublisherQualityLimitationChart = ({
  publishData,
  loading,
}: {
  publishData: peerAnalyticsPublishType;
  loading: boolean;
}) => {
  const peerPublisherQualityLimitationChartoptions: echartsOptions = useMemo(
    () => getPublisherQualityLimitationChartConfiguration(publishData),
    [publishData]
  );

  return (
    <>
      {/* @ts-ignore */}
      <EchartsWrapper
        options={{ ...peerPublisherQualityLimitationChartoptions }}
        loading={loading}
        style={{ height: "300px", width: "auto" }}
      />
    </>
  );
};
